module.exports = __webpack_public_path__ + "static/media/icon_checkbox_checked.47635b6e.svg";